import { useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useMedia } from 'react-use';
import { Paragraph } from '@hungryroot/ramen';
import { getPromoData } from '@hungryroot/rest/api/get_promo_data/get';
import { BreakpointQueryLarge } from '@hungryroot/tokens';

export function useGetFormattedPromo(
  classNameCalloutText: string,
  promoData?: { effect_str?: string | null; effect_base: string },
  classNameBaseText?: string
) {
  const isDesktop = useMedia(BreakpointQueryLarge, false);

  if (promoData === undefined) {
    return;
  }

  const { effect_str, effect_base } = promoData;

  const i = effect_str?.indexOf(effect_base) ?? -1;
  const includesSubStr = i > 0;

  const baseText = includesSubStr
    ? effect_str?.substring(0, i)
    : effect_str ?? '';
  const boldText = includesSubStr ? (
    <span className={classNameCalloutText}>{effect_base}</span>
  ) : undefined;

  return (
    <Paragraph
      variant={isDesktop ? 'caption' : 'body'}
      className={classNameBaseText}
    >
      {baseText}
      {boldText}
    </Paragraph>
  );
}

export function useGetPromoData() {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  const query = useQuery({
    queryKey: ['promo_data', 'homepage'],
    queryFn: async () => {
      const resp = await getPromoData({
        page: 'homepage',
      });

      if (resp.status !== 200) {
        throw resp.data;
      }

      return resp.data;
    },
  });

  if (isMounted === false) {
    return {
      data: undefined,
    };
  }

  return query;
}
